import styled, { css } from 'styled-components';
import { Z_INDEXES } from '../../../src/styled/global-variables';
import { getSizeBy, getColor, getColorShade } from '../../../src/styled/utils';
import { Card, CardContent } from '../card';
const basePositionCSS = css `
  top: 0;
  right: 0;
  bottom: 0;
`;
const genPosition = (position) => {
    if ((position === null || position === void 0 ? void 0 : position.left) || (position === null || position === void 0 ? void 0 : position.left) === 0) {
        return css `
      top: 0;
      bottom: 0;
      left: ${position.left}px;
    `;
    }
    if ((position === null || position === void 0 ? void 0 : position.right) || (position === null || position === void 0 ? void 0 : position.right) === 0) {
        return css `
      top: 0;
      right: ${position.right}px;
      bottom: 0;
    `;
    }
    return basePositionCSS;
};
export const SidebarWrapper = styled(Card) `
  &.react-resizable {
    position: fixed;
  }

  ${({ $position }) => genPosition($position)}
  z-index: ${Z_INDEXES.LIGHTBOX};
  display: flex;
  flex-direction: column;
  height: auto;
  border-radius: 0;
`;
export const SidebarContent = styled(CardContent).attrs({ as: 'main' }) `
  flex-grow: 1;
  padding: 0;
  overflow-y: auto;
`;
export const FooterWrapper = styled.div `
  padding: ${getSizeBy(3.5)} ${getSizeBy(4)};
  border-top: ${getSizeBy(0.25)} solid ${getColor('surface')};
  box-shadow: 0 -${getSizeBy(0.25)} ${getSizeBy(1)} ${getColorShade('onSurface', 'outline')};
`;
export const Shading = styled.div `
  position: fixed;
  z-index: ${Z_INDEXES.LIGHTBOX};
  inset: 0;
  background-color: ${getColorShade('onSurface', 'lowEmphasis')};
`;
